import { motion } from "framer-motion";
import { TRUST } from "../data";

export const TrustBar = () => {
  return (
    <section data-testid="trust-bar" className="bg-[#DC2626]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 md:py-7 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {TRUST.map((t, i) => {
          const Icon = t.icon;
          return (
            <motion.div
              key={t.label}
              data-testid={`trust-item-${i}`}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: i * 0.06 }}
              className="flex items-center gap-3 text-white"
            >
              <span className="w-10 h-10 bg-[#09090B] flex items-center justify-center shrink-0">
                <Icon size={20} className="text-white" />
              </span>
              <span className="font-anton uppercase text-sm md:text-base tracking-wide leading-tight">
                {t.label}
              </span>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};
